export default {
  companyRoles: [],
  permissions: [],
  companyPermissions: [],
};
